import React from "react";
import "./LoginPage.css";
import "./../mvp.css";
import { useAuth } from "../UserProvider";

interface LoginPageProps {}

export const LoginPage: React.FC<LoginPageProps> = () => {
    const { user, logout } = useAuth();

    return (
        <div className="page-login">
            <img className="logo" alt="logo" src="/game/logo.svg"></img>
            {!user && (
                <>
                    <h1>Login</h1>
                    <div>(login disabled for now)</div>
                    {false && (<><a href="/api/login/google">
                        <b>Google ↗</b>
                    </a>
                    <a href="/api/login/twitter">
                        <b>Twitter ↗</b>
                    </a></>)}
                    <a href="/game/play">
                        <em>Just play without login →</em>
                    </a>
                </>
            )}
            {user && (
                <>
                    <h1>Welcome back!</h1>
                    <a href="/game/play">
                        <b>Play →</b>
                    </a>
                    <button
                        onClick={() => logout()}
                        style={{
                            padding: "1rem",
                            fontSize: "smaller",
                            backgroundColor: "transparent",
                            color: "var(--color-link)",
                        }}
                    >
                        <i>Log out</i>
                    </button>
                </>
            )}
        </div>
    );
};
